import { render, staticRenderFns } from "./fixedassets.vue?vue&type=template&id=2b451d90&"
import script from "./fixedassets.vue?vue&type=script&lang=js&"
export * from "./fixedassets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports